/**
 * "Comment voulez-vous l'afficher ?" on desktop (PosterBaseScreen, the cards of
 * shared.components.PosterFinishOptions). On mobile the same choices open in a sheet
 * (shared.popups.PosterOptionsSheet).
 */
fx.ns("shared.screens", class PosterFinitionScreen extends shared.screens.PosterBaseScreen
{
    makeChoices()
    {
        return new shared.components.PosterFinishOptions(this.data, { mobile : false });
    }
});
